import request from './request';
import {IFetchProfileResponseData} from 'models/profile';

export const fetchProfile = () =>
  request.request<IFetchProfileResponseData>({
    url: '/profiles/active/?include-centers=true',
    method: 'GET',
  });
